import type { IndicatorDef } from './indicators';

export function formatValue(def: IndicatorDef, value: number | null): string {
  if (value === null || Number.isNaN(value)) return '—';
  const abs = Math.abs(value);
  let digits = 2;
  if (def.id === 'bch_btc') digits = 5;
  else if (def.unit === '%') digits = 2;
  else if (abs >= 1000) digits = 0;
  else if (abs < 1) digits = 4;

  const num = value.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: digits,
  });

  switch (def.unit) {
    case '%':
      return `${num}%`;
    case 'USD':
      return `$${num}`;
    case 'USD bn':
      return `$${num}B`;
    case 'USD trn':
      return `$${num}T`;
    case '¥':
      return `¥${num}`;
    case '¥ trn':
      return `¥${num}T`;
    case 'sats':
      return `${(value * 1e8).toLocaleString(undefined, { maximumFractionDigits: 0 })} sats`;
    default:
      return num;
  }
}

export function signed(n: number, digits = 0): string {
  const v = n.toLocaleString(undefined, { maximumFractionDigits: digits });
  return n >= 0 ? `+${v}` : v;
}
